.subheader {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.55rem 0.75rem 0.55rem calc(0.75rem + 2px + 0.25rem);
}

.label {
    font-size: 0.6875rem;
    line-height: 1.2;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: var(--mantine-color-gray-7);
}

.count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.15rem;
    height: 1.15rem;
    padding: 0 0.25rem;
    border-radius: var(--mantine-radius-xl);
    background-color: var(--mantine-color-gray-1);
    font-family: var(--mantine-font-family-monospace);
    font-size: 0.625rem;
    line-height: 1;
    font-weight: 600;
    color: var(--mantine-color-gray-7);
    font-variant-numeric: tabular-nums;
}
